import { z } from "zod";
import { schemes } from "@zeal/common";

export const deleteInvoiceTemplateRequestSchema = z.object({
  id: z.string().min(1, "Template ID is required"),
  companyID: schemes.companyID(),
});

export type TDeleteInvoiceTemplateRequest = z.infer<
  typeof deleteInvoiceTemplateRequestSchema
>;

export const deleteInvoiceTemplateResponseSchema = z.object({
  success: z.boolean(),
  template_id: z.string(),
});

export type TDeleteInvoiceTemplateResponse = z.infer<
  typeof deleteInvoiceTemplateResponseSchema
>;
